import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable( {
  providedIn: 'root'
} )
export class SharedService {
  loaderSubject = new BehaviorSubject( { show: false } );
  logoImage = '';
  loginBackground = '';

  showLoader(): void {
    this.loaderSubject.next( { show: true } );
  }

  hideLoader(): void {
    this.loaderSubject.next( { show: false } );
  }

}
